import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c69d6144"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dinh-muc-co-dinh-form-wrapper" }
const _hoisted_2 = { class: "wizard wizard-1" }
const _hoisted_3 = { class: "wizard-nav border-bottom" }
const _hoisted_4 = { class: "wizard-steps p-4 p-lg-6" }
const _hoisted_5 = ["data-wizard-state", "onClick", "onKeyup"]
const _hoisted_6 = { class: "wizard-label" }
const _hoisted_7 = { class: "wizard-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("polygon", { points: "0 0 24 0 24 24 0 24" }),
    /*#__PURE__*/_createElementVNode("rect", {
      fill: "#000000",
      opacity: "0.3",
      transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000)",
      x: "11",
      y: "5",
      width: "2",
      height: "14",
      rx: "1"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C8.29288961,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z",
      fill: "#000000",
      "fill-rule": "nonzero",
      transform: "translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"
    })
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "flex justify-center gap-x-1 mt-5 pb-5 flex-wrap" }
const _hoisted_11 = { class: "mt-8" }

import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
import { ElForm } from "element-plus";

import {
  buildDinhMucCoDinhCreatePayload,
  buildDinhMucCoDinhUpdatePayload,
  DinhMucCoDinhMetaStep,
  DinhMucCoDinhVatTuStep,
  filterDmVatTuLines,
  useDinhMucCoDinhFormMode,
  useDinhMucCoDinhVatTuLines,
  useDinhMucCoDinhWizard,
} from "@/components/dinh-muc-co-dinh";
import DinhMucCoDinhTable from "@/components/dinh-muc-co-dinh/dinh-muc-co-dinh-table/DinhMucCoDinhTable.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import Pagination from "@/components/shared/pagination/Pagination.vue";
import { getGlobalDefaultDate } from "@/core/config/DatePickerConfig";
import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import {
  getErrorMsg,
  lengthValidationRules,
  swalConfirm,
  swalNotification,
} from "@/core/helpers/utils";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import { formatDatePayload } from "@/core/hooks/use-date-time-hook";
import useFormInput from "@/core/hooks/use-form-input";
import { useLoading } from "@/core/hooks/use-loading";
import { usePagination } from "@/core/hooks/use-pagination";
import type {
  ICapSuaChuaResponseBase,
  IDinhMucCoDinhNewResponseBase,
  IVatTuDinhMucCoDinh,
} from "@/core/interfaces/ApiResponses";
import { resolveListPageForRoute } from "@/core/helpers/list-page-context";
import { CapSuaChuaService } from "@/core/services/CapSuaChuaService.service";
import { DinhMucCoDinhService } from "@/core/services/DinhMucCoDinh.service";
import { VatTuService } from "@/core/services/VatTu.service";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import type {
  DinhMucCoDinhCheckResult,
  DinhMucCoDinhFormFields,
  DinhMucCoDinhWillExpire,
  DinhMucCoDinhWizardStep,
} from "@/types/dinh-muc-co-dinh";


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { startLoading, endLoading } = useLoading();
const { formConfig, isCreating } = useDinhMucCoDinhFormMode(route);
const { ButtonTypeColors, ButtonsType } = useButtonCustom();
const { currentPage, perPage, totalItems } = usePagination();
currentPage.value = resolveListPageForRoute(route.query, {
  isCreate: isCreating.value,
});
const { focusFirstErrInputV2 } = useFormInput();

const {
  lines,
  clearLines,
  hydrateFromVatTuDinhMuc,
  hydrateFromVatTuDinhMucList,
  addExistingFromVatTu,
  removeLine,
  patchLine,
} = useDinhMucCoDinhVatTuLines();

const formRef = ref<InstanceType<typeof ElForm> | null>(null);
const metaStepRef = ref<{
  focusFirstField: () => Promise<void>;
  focusDanhMucToaXe: () => Promise<void>;
} | null>(null);
const shouldContinueAfterSave = ref(false);
const items = ref<IDinhMucCoDinhNewResponseBase[]>([]);
const capSuaChuaItems = ref<ICapSuaChuaResponseBase[]>([]);

const createDefaultForm = () => ({
  id_cap_sc: 0,
  id_danh_muc_toa_xe: 0,
  so_van_ban: "",
  ngay_ban_hanh: getGlobalDefaultDate() as Date | string | null,
  ngay_hieu_luc: getGlobalDefaultDate() as Date | string | null,
  ngay_het_han: null as Date | string | null,
  mo_ta: "",
});

const form = reactive(createDefaultForm());

const dinhMucId = computed(() => {
  const fromRoute = Number(route.params.id);

  return fromRoute > 0 ? fromRoute : 0;
});

/** Continues after MetaStep fields (nhóm TX → … → ghi chú = 1–6) */
const META_ACTION_TAB = {
  continue: 7,
} as const;

/** Step 2 buttons (meta fields are hidden) */
const DM_VAT_TU_ACTION_TAB = {
  addVatTu: 1,
  back: 2,
  saveAndContinue: 3,
  save: 4,
  reset: 5,
} as const;

const ngayBanHanhValidation = (_rule, value, callback) => {
  if (!value) {
    callback(new Error("Bắt buộc phải nhập"));
    return;
  }

  callback();
};

const ngayHieuLucValidation = (_rule, value, callback) => {
  if (!value) {
    callback(new Error("Bắt buộc phải nhập"));
    return;
  }

  if (moment(value).isBefore(form.ngay_ban_hanh as Date, "day")) {
    callback(new Error("Ngày hiệu lực phải lớn hơn hoặc bằng ngày ban hành"));
    return;
  }

  callback();
};

const rules = ref({
  id_cap_sc: [
    {
      type: "number",
      min: 1,
      message: "Phải chọn cấp sửa chữa",
      trigger: "change",
    },
  ],
  ngay_ban_hanh: [
    {
      validator: ngayBanHanhValidation,
      trigger: "change",
    },
  ],
  ngay_hieu_luc: [
    {
      validator: ngayHieuLucValidation,
      trigger: "change",
    },
  ],
  so_van_ban: [
    {
      type: "string",
      required: true,
      message: "Số văn bản không được để trống",
      trigger: "change",
    },
    {
      type: "string",
      max: 100,
      message: "Số văn bản tối đa 100 ký tự",
      trigger: "change",
    },
  ],
  mo_ta: lengthValidationRules({
    isRequired: false,
    max: 160,
    name: "Mô tả",
  }),
});

const validateMetaStep = (): Promise<boolean> =>
  new Promise((resolve) => {
    if (!formRef.value) {
      resolve(false);

      return;
    }

    formRef.value.validate(async (valid) => {
      if (!valid) {
        await focusFirstErrInputV2();
        resolve(false);

        return;
      }

      if (!form.id_danh_muc_toa_xe || form.id_danh_muc_toa_xe < 1) {
        await swalNotification("Phải chọn nhóm toa xe", "error");
        resolve(false);

        return;
      }

      if (!form.id_cap_sc || form.id_cap_sc < 1) {
        await swalNotification("Phải chọn cấp sửa chữa", "error");
        resolve(false);

        return;
      }

      resolve(true);
    });
  });

const {
  step,
  steps,
  currentStepMeta,
  isMetaStep,
  isDmVatTuStep,
  goToDmVatTu: advanceToDmVatTu,
  goBack,
  resetWizard,
} = useDinhMucCoDinhWizard({
  onBeforeLeaveMeta: validateMetaStep,
});

const goToDmVatTu = async () => {
  await advanceToDmVatTu();
};

const onStepClick = async (target: DinhMucCoDinhWizardStep) => {
  if (target === "dmVatTu") {
    await goToDmVatTu();

    return;
  }

  goBack();
};

const wizardStepState = (item: {
  id: DinhMucCoDinhWizardStep;
  index: number;
}) => {
  if (item.id === step.value) {
    return "current";
  }

  if (item.index < currentStepMeta.value.index) {
    return "done";
  }

  return "pending";
};

const patchForm = (patch: Partial<typeof form>) => {
  Object.assign(form, patch);
};

const buildDinhMucCoDinhFields = (): DinhMucCoDinhFormFields => {
  const fields: DinhMucCoDinhFormFields = {
    id_cap_sc: form.id_cap_sc,
    id_danh_muc_toa_xe: form.id_danh_muc_toa_xe,
    so_van_ban: form.so_van_ban,
    ngay_ban_hanh: formatDatePayload(form.ngay_ban_hanh as Date | string),
    ngay_hieu_luc: formatDatePayload(form.ngay_hieu_luc as Date | string),
    ngay_het_han: form.ngay_het_han
      ? formatDatePayload(form.ngay_het_han as Date | string)
      : null,
  };

  if (form.mo_ta?.trim()) {
    fields.mo_ta = form.mo_ta.trim();
  }

  return fields;
};

const clearForm = async () => {
  Object.assign(form, createDefaultForm());
  clearLines();
  resetWizard();

  await nextTick();
  formRef.value?.clearValidate();
  await metaStepRef.value?.focusFirstField();
};

const fetchData = async () => {
  try {
    await startLoading();

    const {
      data: {
        data: { data, total },
      },
    } = await DinhMucCoDinhService.getList({
      current_page: currentPage.value,
      per_page: perPage.value,
    });

    items.value = data;
    totalItems.value = total;
    await endLoading();
  } catch (error) {
    await endLoading();

    await swalNotification(getErrorMsg(error, "Có lỗi xảy ra"), "error");
  }
};

const refreshFirstPage = async () => {
  if (currentPage.value !== 1) {
    currentPage.value = 1;

    return;
  }

  await fetchData();
};

const fetchVatTuForEdit = async (id: number) => {
  try {
    const {
      data: {
        data: { data },
      },
    } = await VatTuService.getVatTuItemsByDinhMucCoDinhId({
      id_dinh_muc: id,
      current_page: 1,
      per_page: 1000,
    });

    hydrateFromVatTuDinhMucList(data);
  } catch {
    // Fallback handled by caller if detail.vat_tu exists
  }
};

const fetchDinhMucDetail = async (id: number) => {
  try {
    await startLoading();

    const {
      data: { data },
    } = await DinhMucCoDinhService.get(id);

    const {
      cap_sua_chua: { ten_cap_sc },
      danh_muc_toa_xe: { ten_danh_muc },
    } = data as IDinhMucCoDinhNewResponseBase;

    const dinhMucDetail: IDinhMucCoDinhNewResponseBase = data;
    setCurrentPageTitle(`${ten_cap_sc} - (${ten_danh_muc})`);

    if (dinhMucDetail.ngay_het_han) {
      const today = moment();
      const expiryDate = moment(dinhMucDetail.ngay_het_han);

      if (today.isAfter(expiryDate, "day")) {
        await endLoading();

        await swalNotification(
          "Không thể chỉnh sửa định mức cố định đã hết hạn",
          "warning"
        );

        await router.replace({
          path: `/quan-ly/dinh-muc-co-dinh/chi-tiet/${id}`,
        });

        return;
      }
    }

    form.mo_ta = dinhMucDetail.mo_ta || "";
    form.so_van_ban = dinhMucDetail.so_van_ban || "";
    form.ngay_ban_hanh = dinhMucDetail.ngay_ban_hanh
      ? new Date(dinhMucDetail.ngay_ban_hanh)
      : getGlobalDefaultDate();
    form.ngay_hieu_luc = dinhMucDetail.ngay_hieu_luc
      ? new Date(dinhMucDetail.ngay_hieu_luc)
      : dinhMucDetail.ngay_ban_hanh
        ? new Date(dinhMucDetail.ngay_ban_hanh)
        : getGlobalDefaultDate();
    form.ngay_het_han = dinhMucDetail.ngay_het_han
      ? new Date(dinhMucDetail.ngay_het_han)
      : null;
    form.id_cap_sc = dinhMucDetail.id_cap_sc || 0;
    form.id_danh_muc_toa_xe = dinhMucDetail.id_danh_muc_toa_xe || 0;

    clearLines();

    if (dinhMucDetail.vat_tu?.length) {
      hydrateFromVatTuDinhMuc(
        dinhMucDetail.vat_tu as IVatTuDinhMucCoDinh[]
      );
    } else {
      await fetchVatTuForEdit(id);
    }

    document.title = `ID ${id} - Chỉnh sửa - Định mức cố định - Đường sắt Hà Nội`;

    await endLoading();
  } catch (e) {
    await endLoading();

    await swalNotification(
      getErrorMsg(e, "Có lỗi khi lấy thông tin định mức cố định"),
      "error"
    );
  }
};

const onSaveIntent = async (shouldContinue = false) => {
  const metaOk = await validateMetaStep();

  if (!metaOk) {
    resetWizard();

    return;
  }

  if (filterDmVatTuLines(lines.value).length === 0) {
    await swalNotification(
      "Bắt buộc phải thêm ít nhất một vật tư có số lượng lớn hơn 0",
      "error"
    );

    return;
  }

  shouldContinueAfterSave.value = shouldContinue;

  const dinhMucCoDinh = buildDinhMucCoDinhFields();
  const dmVatTu = filterDmVatTuLines(lines.value);

  try {
    await startLoading();

    const {
      data: { data: checkResult },
    } = await DinhMucCoDinhService.check({
      ...(isCreating.value ? {} : { id: dinhMucId.value }),
      dinhMucCoDinh,
      dmVatTu,
    });

    await endLoading();

    if (!checkResult.can_save || checkResult.duplicate) {
      await swalNotification(
        formatCheckBlockMessage(checkResult),
        "error"
      );

      return;
    }

    if (checkResult.will_expire) {
      const confirmed = await confirmWillExpire(
        checkResult.will_expire,
        checkResult.message
      );

      if (!confirmed) {
        return;
      }
    }

    await onSubmit();
  } catch (error) {
    await endLoading();

    await swalNotification(
      getErrorMsg(error, "Có lỗi khi kiểm tra định mức cố định"),
      "error"
    );
  }
};

const formatCheckBlockMessage = (result: DinhMucCoDinhCheckResult): string => {
  if (result.errors?.length) {
    return result.errors.join("\n");
  }

  if (result.message?.trim()) {
    return result.message.trim();
  }

  if (result.duplicate?.id) {
    const soVanBan = result.duplicate.so_van_ban
      ? ` (${result.duplicate.so_van_ban})`
      : "";

    return `Định mức trùng lặp ID ${result.duplicate.id}${soVanBan}`;
  }

  return "Không thể lưu định mức cố định";
};

const formatNgayHetHanMoi = (value: string): string => {
  const parsed = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601], true);

  if (parsed.isValid()) {
    return parsed.format("DD/MM/YYYY");
  }

  return value;
};

const confirmWillExpire = async (
  willExpire: DinhMucCoDinhWillExpire,
  apiMessage?: string
): Promise<boolean> => {
  const ngayHetHanMoi = formatNgayHetHanMoi(willExpire.ngay_het_han_moi);
  const text =
    apiMessage?.trim() ||
    `Định mức ID ${willExpire.id} sẽ hết hạn thành ${ngayHetHanMoi}`;

  return swalConfirm({
    title: "Xác nhận",
    text,
    icon: "warning",
    confirmButtonText: "Đồng ý",
    cancelButtonText: "Hủy bỏ",
  });
};

const onSubmit = async () => {
  const dinhMucCoDinh = buildDinhMucCoDinhFields();

  try {
    await startLoading();

    let savedId = dinhMucId.value;

    if (isCreating.value) {
      const res = await DinhMucCoDinhService.create(
        buildDinhMucCoDinhCreatePayload({
          dinhMucCoDinh,
          lines: lines.value,
        })
      );

      const created = res?.data?.data ?? res?.data;
      savedId = (created as IDinhMucCoDinhNewResponseBase)?.id ?? 0;

      const resAny = res as {
        data?: { extra?: { message?: string } };
        extra?: { message?: string };
      };
      const createdAny = created as { extra?: { message?: string } };
      const extraMessage =
        resAny?.data?.extra?.message ??
        resAny?.extra?.message ??
        createdAny?.extra?.message;

      await endLoading();

      await swalNotification(formConfig.value.submitCreateMessage, "success");

      if (extraMessage) {
        await swalNotification(extraMessage, "info");
      }
    } else {
      const res = await DinhMucCoDinhService.update(
        dinhMucId.value,
        buildDinhMucCoDinhUpdatePayload({
          dinhMucCoDinh,
          lines: lines.value,
        })
      );

      const resAny = res as {
        data?: { extra?: { message?: string } };
        extra?: { message?: string };
      };
      const extraMessage =
        resAny?.data?.extra?.message ?? resAny?.extra?.message;

      await endLoading();

      await swalNotification(formConfig.value.submitUpdateMessage, "success");

      if (extraMessage) {
        await swalNotification(extraMessage, "info");
      }
    }

    if (shouldContinueAfterSave.value && isCreating.value) {
      await clearForm();
      await refreshFirstPage();

      return;
    }

    if (savedId > 0) {
      await router.replace({
        name: "chi-tiet-dinh-muc-co-dinh",
        params: { id: String(savedId) },
      });

      return;
    }

    await router.replace({
      name: "danh-sach-dinh-muc-co-dinh",
    });
  } catch (error) {
    await endLoading();

    await swalNotification(getErrorMsg(error, "Có lỗi xảy ra"), "error");
  }
};

onMounted(async () => {
  const breadcrumbs = [
    {
      text: "Định mức cố định",
      routeData: {
        name: "danh-sach-dinh-muc-co-dinh",
      },
    },
  ];

  if (!isCreating.value) {
    breadcrumbs.push({
      text: "Chỉnh sửa",
      routeData: {
        name: "chinh-sua-dinh-muc-co-dinh",
      },
    });
  }

  setBreadcrumbLinks(breadcrumbs);

  try {
    await startLoading();

    const {
      data: {
        data: { data: capSuaChuaResponse },
      },
    } = await CapSuaChuaService.list({ per_page: 1000 });

    capSuaChuaItems.value = capSuaChuaResponse || [];

    if (!isCreating.value) {
      await fetchDinhMucDetail(dinhMucId.value);
    } else {
      if (route.query["id-danh-muc-toa-xe"]) {
        form.id_danh_muc_toa_xe = +route.query["id-danh-muc-toa-xe"];
      }

      if (route.query["id-cap-sua-chua"]) {
        form.id_cap_sc = +route.query["id-cap-sua-chua"];
      }

      document.title = "Tạo mới - Định mức cố định - Đường sắt Hà Nội";
      setCurrentPageTitle(formConfig.value.pageTitle);
    }

    await endLoading();
  } catch (e) {
    form.id_danh_muc_toa_xe = 0;

    await endLoading();

    await swalNotification(
      getErrorMsg(e, "Có lỗi khi lấy thông tin nhóm toa xe"),
      "error"
    );
  }

  await fetchData();

  await nextTick();
  await metaStepRef.value?.focusFirstField();
});

watch(
  () => form.ngay_ban_hanh,
  (ngayBanHanh) => {
    if (
      ngayBanHanh &&
      (!form.ngay_hieu_luc ||
        moment(form.ngay_hieu_luc).isBefore(ngayBanHanh as Date, "day"))
    ) {
      form.ngay_hieu_luc = new Date(ngayBanHanh as Date);
    }
  }
);

/** Reload form when navigating between create/edit or another item from the list */
watch(
  () => [dinhMucId.value, isCreating.value] as const,
  async ([id, creating], [prevId, prevCreating]) => {
    if (creating) {
      currentPage.value = resolveListPageForRoute(route.query, {
        isCreate: true,
      });
      return;
    }

    if (!id || (id === prevId && !prevCreating)) {
      return;
    }

    currentPage.value = resolveListPageForRoute(route.query, {
      isCreate: false,
    });
    resetWizard();
    await fetchDinhMucDetail(id);
    await nextTick();
    await metaStepRef.value?.focusFirstField();
  }
);

watch(
  () => currentPage.value,
  () => {
    fetchData();
  }
);

watch(
  () => perPage.value,
  () => {
    if (currentPage.value === 1) {
      fetchData();

      return;
    }

    currentPage.value = 1;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContentBase, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(steps), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "wizard-step",
                  "data-wizard-type": "step",
                  "data-wizard-state": wizardStepState(item),
                  role: "button",
                  tabindex: "0",
                  onClick: ($event: any) => (onStepClick(item.id)),
                  onKeyup: _withKeys(($event: any) => (onStepClick(item.id)), ["enter"])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("i", {
                      class: _normalizeClass(['wizard-icon', item.iconClass])
                    }, null, 2),
                    _createElementVNode("h3", _hoisted_7, _toDisplayString(item.label), 1)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["svg-icon svg-icon-xl wizard-arrow", { last: index === _unref(steps).length - 1 }])
                  }, _hoisted_9, 2)
                ], 40, _hoisted_5))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_unref(ElForm), {
          ref_key: "formRef",
          ref: formRef,
          class: "form mt-6",
          model: form,
          rules: rules.value,
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_unref(DinhMucCoDinhMetaStep), {
              ref_key: "metaStepRef",
              ref: metaStepRef,
              form: form,
              "cap-sua-chua-items": capSuaChuaItems.value,
              "onUpdate:form": patchForm
            }, null, 8, ["form", "cap-sua-chua-items"]), [
              [_vShow, _unref(isMetaStep)]
            ]),
            _withDirectives(_createVNode(_unref(DinhMucCoDinhVatTuStep), {
              lines: _unref(lines),
              "add-button-tabindex": DM_VAT_TU_ACTION_TAB.addVatTu,
              onRemoveLine: _unref(removeLine),
              onPatchLine: _unref(patchLine),
              onAddExisting: _unref(addExistingFromVatTu)
            }, null, 8, ["lines", "add-button-tabindex", "onRemoveLine", "onPatchLine", "onAddExisting"]), [
              [_vShow, _unref(isDmVatTuStep)]
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_unref(isDmVatTuStep))
                ? (_openBlock(), _createBlock(ButtonCustom, {
                    key: 0,
                    classes: `rounded-none m-0`,
                    "button-type": _unref(ButtonsType).BACK,
                    "color-type": _unref(ButtonTypeColors).SECONDARY,
                    tabindex: DM_VAT_TU_ACTION_TAB.back,
                    onClick: _unref(goBack)
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Quay lại")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type", "tabindex", "onClick"]))
                : _createCommentVNode("", true),
              (_unref(isMetaStep))
                ? (_openBlock(), _createBlock(ButtonCustom, {
                    key: 1,
                    classes: `rounded-none m-0`,
                    "button-type": _unref(ButtonsType).FORWARD,
                    "color-type": _unref(ButtonTypeColors).PRIMARY,
                    tabindex: META_ACTION_TAB.continue,
                    onClick: goToDmVatTu
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Tiếp tục")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type", "tabindex"]))
                : _createCommentVNode("", true),
              (_unref(isDmVatTuStep))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_unref(isCreating))
                      ? (_openBlock(), _createBlock(ButtonCustom, {
                          key: 0,
                          classes: `rounded-none m-0`,
                          "button-type": _unref(ButtonsType).ADD,
                          "color-type": _unref(ButtonTypeColors).PRIMARY,
                          tabindex: DM_VAT_TU_ACTION_TAB.saveAndContinue,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (onSaveIntent(true)))
                        }, {
                          "button-label": _withCtx(() => [
                            _createTextVNode("Lưu và tiếp tục")
                          ]),
                          _: 1
                        }, 8, ["button-type", "color-type", "tabindex"]))
                      : _createCommentVNode("", true),
                    _createVNode(ButtonCustom, {
                      classes: `rounded-none m-0`,
                      "button-type": _unref(ButtonsType).SAVE,
                      "color-type": _unref(ButtonTypeColors).SUCCESS,
                      tabindex: DM_VAT_TU_ACTION_TAB.save,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onSaveIntent(false)))
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Lưu")
                      ]),
                      _: 1
                    }, 8, ["button-type", "color-type", "tabindex"]),
                    (_unref(isCreating))
                      ? (_openBlock(), _createBlock(ButtonCustom, {
                          key: 1,
                          classes: `rounded-none m-0`,
                          "color-type": _unref(ButtonTypeColors).WARNING,
                          "button-type": _unref(ButtonsType).REFRESH,
                          tabindex: DM_VAT_TU_ACTION_TAB.reset,
                          onClick: clearForm
                        }, {
                          "button-label": _withCtx(() => [
                            _createTextVNode("Nhập lại")
                          ]),
                          _: 1
                        }, 8, ["color-type", "button-type", "tabindex"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(DinhMucCoDinhTable, {
          "cur-page": _unref(currentPage),
          items: items.value,
          "per-page": _unref(perPage),
          "selected-id": dinhMucId.value,
          "show-so-luong-vat-tu": false
        }, null, 8, ["cur-page", "items", "per-page", "selected-id"]),
        (_unref(totalItems) > 0)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 0,
              page: _unref(currentPage),
              "page-size": _unref(perPage),
              total: _unref(totalItems),
              onChangePage: _cache[3] || (_cache[3] = (value) => (currentPage.value = value)),
              onChangePageSize: _cache[4] || (_cache[4] = (value) => (perPage.value = value))
            }, null, 8, ["page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})